<template>
  <div>
    <OsiguDrawer />
    <v-main>
      <router-view></router-view>
    </v-main>
    <OsiguFooter />
  </div>
</template>

<script>
import OsiguDrawer from "@/components/v2/drawer/OsiguDrawer.vue";
import OsiguFooter from "@/components/v2/footer/OsiguFooter.vue";

export default {
  name: "HomeLayoutV2",
  components: {
    OsiguDrawer,
    OsiguFooter
  },
};
</script>
